export default __webpack_public_path__ + "static/IMG_8135-71f03cec8177faea157d409ece4adba9.jpeg";